import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  turnitinEulaRequest,
  turnitinEulaSuccess,
  turnitinEulaFailure,
  turnitinRequest,
  setEulaAcceptance,
} from '../reducers/turnitin';

import { API_LINK, TURNITIN_EULA_LANGUAGE, TURNITIN_EULA_VERSION_LATEST } from '../../constants';
import moment from 'moment';
import { buildTurnitinEulaAcceptPayload } from '../../utils/buildTurnitinSubmissionPayload';

const API = `${API_LINK}api`;

function* turnitinEulaFunctionAxios() {
  const state = yield select(fullState => fullState);
  const { user, token } = state.loginReducer;
  const { eulaVersion } = state.turnitinReducer;

  const acceptedTimestamp = moment().utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
  const version = eulaVersion || TURNITIN_EULA_VERSION_LATEST;
  const data = JSON.stringify(
    buildTurnitinEulaAcceptPayload({
      userId: user.userId,
      version,
      language: TURNITIN_EULA_LANGUAGE,
      acceptedTimestamp,
    }),
  );

  const response = yield call(() =>
    axios({
      method: 'post',
      url: `${API}/assessor/tii_acceptEula`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: {
        tii_data: data,
      },
    }),
  );

  return {
    response,
    acceptedTimestamp,
    version,
  };
}

function* workerTurnitinEulaSaga() {
  try {
    const { response, acceptedTimestamp, version } = yield call(turnitinEulaFunctionAxios);
    const responseFromTurnitinEula = response.data;

    if (response.status === 200) {
      const acceptance = {
        version: responseFromTurnitinEula.version || version,
        accepted_timestamp: responseFromTurnitinEula.accepted_timestamp || acceptedTimestamp,
        language: responseFromTurnitinEula.language || TURNITIN_EULA_LANGUAGE,
      };
      yield put(setEulaAcceptance(acceptance));
      yield put(turnitinEulaSuccess(acceptance));
      yield put(turnitinRequest());
    }
    if (response.status === 201) {
      yield put(turnitinEulaFailure(responseFromTurnitinEula.message));
    }
  } catch (error) {
    yield put(turnitinEulaFailure(error.message));
  }
}

export function* watcherTurnitinEulaSaga() {
  yield takeLatest(turnitinEulaRequest().type, workerTurnitinEulaSaga);
}
